// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__8gle9","innerFooter":"styles_innerFooter__-y-tz","left":"styles_left__ReXeI","right":"styles_right__EJHhK","footerLink":"styles_footerLink__U9Y++"};